// Resolver
import { MaintenanceResolver } from './core/resolvers/maintenance.resolver';
// Angular
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Guard
import { AuthGuard } from './core/guards/auth.guard';
import { MobileGuard } from '@core/guards/mobile.guard';
import { MaintenanceGuard } from '@core/guards/maintenance.guard';
import { ChangePasswordMsgResolver } from '@core/resolvers/change-password-msg.resolver';
import { CleanModeGuard } from '@core/guards/clean-mode.guard';

import { environment } from '@env/environment';
const qpro9Routes: Routes = (environment.sitePrefix?.toLowerCase() === 'mint33')
  ? [{
      path: 'mint-girl',
      loadChildren: () => import('./views/modules/mint-girl/mint-girl.module').then(m => m.MintGirlModule),
      data: { title: 'Mint Girl' },
      resolve: {
        mintgirl: MaintenanceResolver,
        profile: ChangePasswordMsgResolver
      },
      canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard],
      }]
  : [];

const routes: Routes = [
  // add qpro9 routes
  ...qpro9Routes,

  // Member Module
  {
    path: 'member',
    loadChildren: () => import('./views/modules/member/member.module').then(m => m.MemberModule),
    data: { title: 'Member' },
    resolve: {
      member: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard],
    canActivateChild: [AuthGuard],
  },
  // Lucky Spin Module
  {
    path: 'luckyspin',
    loadChildren: () => import('./views/modules/lucky-spin/lucky-spin.module').then(m => m.LuckySpinModule),
    data: { title: 'Lucky Spin' },
    resolve: {
      luckyspin: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard]
  },
  // Info Module
  {
    path: 'info',
    loadChildren: () => import('./views/modules/info/info.module').then(m => m.InfoModule),
    data: { title: 'Info' },
    resolve: {
      content: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard]
  },
  {
    path: 'external',
    loadChildren: () => import('./views/modules/external-link/external-link.module').then(m => m.ExternalLinkModule),
    data: { title: 'External Link' },
    resolve: {
      content: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard]
  },
  // Referral Module
  {
    path: 'referral',
    loadChildren: () => import('./views/modules/referral/referral.module').then(m => m.ReferralModule),
    data: { title: 'Referral' },
    resolve: {
      referral: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard]
  },
  // VIP Module
  {
    path: 'vip',
    loadChildren: () => import('./views/modules/vip/vip.module').then(m => m.VipModule),
    data: { title: 'VIP' },
    resolve: {
      vip: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard]
  },
  // Promotion Module
  {
    path: 'promotion',
    loadChildren: () => import('./views/modules/promotion/promotion.module').then(m => m.PromotionModule),
    data: { title: 'Promotion' },
    resolve: {
      promotion: MaintenanceResolver,
      profile: ChangePasswordMsgResolver
    },
    canActivate: [MobileGuard, MaintenanceGuard, CleanModeGuard]
  },
  // Ambassador Module
  // {
  //   path: 'ambassador',
  //   loadChildren: () => import('./views/modules/ambassador/ambassador.module').then(m => m.AmbassadorModule),
  //   data: { title: 'Ambassador' },
  //   resolve: {
  //     promotion: MaintenanceResolver,
  //     profile: ChangePasswordMsgResolver
  //   },
  //   canActivate: [MobileGuard, MaintenanceGuard]
  // },
  // Main Module ** Game Module moved into this module **
  {
    path: '',
    loadChildren: () => import('./views/modules/main/main.module').then(m => m.MainModule)
  },
  // Default
  {
    path: '**', redirectTo: '/', pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
